import { Box, Typography } from '@mui/material';
import { useWindowSize } from '@uidotdev/usehooks';
import * as React from 'react';

function formatEuroNoDecimals(n) {
  if (n == null) return '-';
  return `${new Intl.NumberFormat('el-GR').format(Math.round(n))} ευρώ`;
}

export default function IncomesSection({ incomes }) {
  const { width } = useWindowSize();
  const isMobileView = width < 1023;
  const isIPadView = width >= 1024 && width <= 1224;
  const isLaptopView = width >= 1225 && width <= 1540;

  // ensure newest year first; stable order within year by kad then id
  const sorted = React.useMemo(
    () =>
      [...incomes].sort(
        (a, b) =>
          b.tax_year - a.tax_year ||
          String(a.kad).localeCompare(String(b.kad)) ||
          String(a.id).localeCompare(String(b.id))
      ),
    [incomes]
  );

  // group by year (preserve the sorted order)
  const groups = React.useMemo(() => {
    const map = new Map();
    for (const r of sorted) {
      if (!map.has(r.tax_year)) map.set(r.tax_year, []);
      map.get(r.tax_year).push(r);
    }
    return Array.from(map.entries()); // [ [2024, [...]],[2023,[...]] ]
  }, [sorted]);

  const gridTemplateColumns = React.useMemo(() => {
    if (isMobileView) return '250px 1fr';
    if (isIPadView) return '210px 1fr';
    if (isLaptopView) return '410px 1fr';
    return '550px 1fr';
  }, [isMobileView, isIPadView, isLaptopView]);

  return (
    <Box>
      {incomes.length > 0 && (
        <Box my={3}>
          <Box display="flex" alignItems="center" gap={1} my={1}>
            <Typography fontWeight={600}>Στοιχεία Εισοδημάτων</Typography>
            <Typography variant="body2" color="text.secondary">
              (εφόσον όλοι οι ΚΑΔ σε ένα έτος εντάσσονται στον Πολιτιστικό και
              Δημιουργικό Τομέα)
            </Typography>
          </Box>
          <Box mt={1.5}>
            {groups.map(([year, items]) => (
              <Box key={year} mb={2.5}>
                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                  Φορολογικό Έτος {year}
                </Typography>

                {items.map((row) => (
                  <Box
                    key={row.id}
                    display="grid"
                    gridTemplateColumns={gridTemplateColumns}
                    alignItems="center"
                    justifyContent="space-between"
                    py={0.75}
                    borderBottom="1px solid"
                    borderColor="divider"
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="body1">ΚΑΔ</Typography>
                      <Typography variant="body1">{row.kad}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography variant="body1">Εισόδημα</Typography>
                      <Typography variant="body1">
                        {formatEuroNoDecimals(row.income)}
                      </Typography>
                    </Box>

                    <Box></Box>
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
